module.exports = __webpack_public_path__ + "static/img/icon_2_mk.ad11d8b3.svg";